module.exports = __webpack_public_path__ + "static/media/renove.620a1f99.jpg";